import Insurance_Minimal from './Insurance_Minimal'

export default {
    Insurance_Minimal,
}
